import { useQueryClient } from '@tanstack/react-query';
import * as React from 'react';
import Suspense from '../../../../App/Suspense';
import { useInfiniteIdentityNotificationsQuery } from '../../../../generated/core-api/graphql-react-query';
import useInfiniteScroll from '../../../../Hooks/useInfiniteScroll';
import NotificationList from './NotificationList';
import StyledPopover from './styles';

interface NotificationMenuProps {
  anchorEl: HTMLElement | null;
  setAnchorEl: (value: React.SetStateAction<HTMLElement | null>) => void;
}

export default function NotificationMenu(props: NotificationMenuProps) {
  const { anchorEl, setAnchorEl } = props;
  const queryClient = useQueryClient();
  const notifications = useInfiniteIdentityNotificationsQuery(
    'nextToken',
    { nextToken: undefined },
    {
      getNextPageParam: (lastPage) => {
        const { nextToken } = lastPage.queryIdentityNotifications;
        if (nextToken) {
          return { nextToken };
        }
        return undefined;
      },
      enabled: !!anchorEl,
    },
  );

  const fetchNextPage = React.useCallback(
    () => {
      if (notifications.hasNextPage) {
        notifications.fetchNextPage();
      }
    },
    [notifications],
  );

  const [ref, setRef] = React.useState<HTMLDivElement | null>(null);
  const { onScroll } = useInfiniteScroll<HTMLDivElement>(ref, fetchNextPage);

  React.useEffect(() => {
    if (anchorEl) {
      queryClient.invalidateQueries(['identityNotifications.infinite']);
      setTimeout(() => {
        queryClient.invalidateQueries(['identityNumNotifications']);
      }, 3000);
    }
  }, [anchorEl]);

  return (
    <Suspense>
      <StyledPopover
        anchorEl={anchorEl}
        id="more-menu"
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ ref: setRef, onScroll }}
      >
        <NotificationList onClose={() => setAnchorEl(null)} />
      </StyledPopover>
    </Suspense>
  );
}
